var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"descriptions flex-1 w-full h-35px leading-35px"},[_c('span',{staticClass:"text-16px text-white ml-15px font-bold"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }